import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Stack, Alert } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import RHFMobileField from '../../../components/hook-form/RHFMobileField';
import { snackActions } from '../../../components/notistack/SnackbarUtilsConfigurator';
import { getOtp } from '../../../services/authServices';
import { FormProvider } from '../../../components/hook-form';

import { t } from 'i18next';

const LoginOtpForm = ({ onNext }) => {
  const schema = Yup.object().shape({
    username: Yup.string().required('شماره همراه را وارد کنید'),
  });

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: { username: '' },
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {    
    const response = await getOtp({username:data.username,zone:'panel'});
    if (response.status < 500 && response.data.status_code === 1001) {
      snackActions.success(response.data.message);
      onNext(data.username);
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        <Alert severity="info"> {t('You can use your contact number to log in')}</Alert>
        <RHFMobileField name="username" label="شماره همراه" type="tel" inputMode="tel" />
        <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
          ورود
        </LoadingButton>
      </Stack>
    </FormProvider>
  );
};

export default LoginOtpForm;
